import React from 'react';
import type { BirthdaySectionBackground } from '../content';

/**
 * Renders absolute-positioned background image + overlay divs inside a
 * `position: relative` section element. Returns null when disabled or no
 * imageUrl is set — caller keeps its own default gradient in that case.
 */
export function hasSectionBg(bg: BirthdaySectionBackground | undefined): boolean {
  return Boolean(bg?.enabled && bg.imageUrl);
}

export function SectionBgImage({ bg }: { bg: BirthdaySectionBackground | undefined }) {
  if (!hasSectionBg(bg)) return null;
  return (
    <>
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${bg!.imageUrl})` }}
        aria-hidden="true"
      />
      <div
        className="absolute inset-0"
        style={{
          background: bg!.overlayStyle === 'light'
            ? 'rgba(255,255,255,0.35)'
            : 'rgba(0,0,0,0.58)',
        }}
        aria-hidden="true"
      />
    </>
  );
}
